/**
 * L'ABSENCE DE PHOTO — des hachures, jamais un blanc ni une pastille de couleur.
 *
 * ⚠️ UN CARRÉ VIDE SE LIT COMME UNE IMAGE QUI N'A PAS FINI DE CHARGER, et on attend ; une pastille se lit comme le
 *    coloris de l'article. Les hachures disent « il n'y en a pas » — une information, et une invitation à en poser une.
 * ⚠️ LE SIÈGE ET LA CAISSE LES LISENT ICI : le motif CSS du back-office (`noPhotoHatchCss`) et celui de la tablette
 *    (`NoPhotoHatch`, `@orgazone/ui-native`) sont deux rendus d'un même dessin.
 * - `angle` : l'angle du dégradé CSS (0 = vers le haut, sens horaire) ;
 * - `stripe` : la largeur d'une bande, en pixels ;
 * - `inks` : les deux crans de l'encre du thème, le plus clair d'abord.
 */
export const NO_PHOTO_HATCH = { angle: 45, stripe: 4, inks: [100, 200] } as const;

/** Le motif en CSS — l'arrière-plan d'une case sans photo, sur les variables d'encre du thème (clair ou sombre). */
export function noPhotoHatchCss(): string {
  const { angle, stripe, inks: [light, dark] } = NO_PHOTO_HATCH;
  return `repeating-linear-gradient(${angle}deg, var(--ink-${light}), var(--ink-${light}) ${stripe}px, `
    + `var(--ink-${dark}) ${stripe}px, var(--ink-${dark}) ${stripe * 2}px)`;
}

/**
 * LA ROTATION SVG QUI DONNE CES HACHURES À UN MOTIF DE BANDES VERTICALES — la tablette n'a pas de CSS.
 * ⚠️ LES DEUX CONVENTIONS NE COMPTENT PAS PAREIL : l'angle CSS part du HAUT, la rotation SVG de l'axe horizontal, dans le
 *    même sens horaire — d'où le quart de tour. Écrit tel quel (45), le motif natif pencherait dans l'autre sens.
 */
export function noPhotoHatchRotation(): number {
  return NO_PHOTO_HATCH.angle - 90;
}
